import { Path, Svg } from 'react-native-svg';

type IconLogoProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
};

export const IconLogo = ({ width, height, color }: IconLogoProps) => {
  return (
    <Svg viewBox="0 0 469.46 522.97" width={width} height={height}>
      <Path
        fill={color}
        d="M0 131.56V52.72C0 31.24 29.79 1.52 50.54 0l345.32.35c56.21 9.65 69.63 88.29 22.99 120.9-3.68 2.57-20.97 10.31-24.39 10.31H0zM0 327.16v-78.84c0-21.48 31.28-51.2 53.06-52.72l362.57.35c59.02 9.65 73.11 88.29 24.13 120.9-3.86 2.57-22.02 10.31-25.61 10.31H0zM0 522.77v-78.84c0-21.49 26.31-52.73 63.33-52.73h247.35c0 12.87-.09 43.19-.05 75.04.05 34.31-36.75 56.83-67.18 56.73-35.77-.11-91.31-.21-91.63-.21H0z"
      />
    </Svg>
  );
};
